<div>
  <div class="row">
    <div class="col title-col">
      <mat-icon svgIcon="suitcase-job-history-clock"></mat-icon>
      <h1>{{ ("pastEmployments" | i18n) || "Vergangene Dienste" }}</h1>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col log-entry-text">
      {{ ("pastThreeMonthsDescription" | i18n) || "in den letzten 3 Monaten" }}
    </div>
  </div>
  <ng-container *ngIf="!isLoading; else loadingTemplate">
    <div class="row mb-1">
      <div class="col log-large-text">
        <span class="log-entry-highlight">{{ countInDepartment }}</span>
        {{ ("in" | i18n) || "bei" }}
        <span class="log-entry-highlight">{{ departmentName }}</span>
        {{ ("worked" | i18n) || "gearbeitet" }}.
      </div>
    </div>
    <div class="row mb-3">
      <div class="col log-large-text">
        <span class="log-entry-secondary-highlight">{{
          countInOrganisation
        }}</span>
        {{ ("in" | i18n) || "bei" }}
        <span class="log-entry-secondary-highlight">{{
          organisation?.name
        }}</span>
        {{ ("worked" | i18n) || "gearbeitet" }}.
      </div>
    </div>
    <div class="spacer-bar mb-1"></div>
    <div class="row">
      <div class="col">
        <div
          class="py-2"
          *ngFor="let employment of recentEmployments">
          <div class="row mb-1">
            <div class="col date-col">
              <div class="log-entry-date">
                {{ employment.startDate | date }} -
                {{ employment.endDate | date }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col log-entry-organisation-name">
              <span
                [class.log-entry-highlight]="
                  employment.department.id === data.departmentId
                "
                >{{ employment.department.displayName }}</span
              >
              {{ organisation?.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spacer-bar"></div>
    <div class="row mb-3">
      <div class="col log-entry-text">
        <div>
          {{
            ("moreThanThreeMonthsDescription" | i18n) ||
              "vor mehr als 3 Monaten"
          }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div
          class="py-2"
          *ngFor="let employment of oldEmployments">
          <div class="row mb-1">
            <div class="col date-col">
              <div class="log-entry-date">
                {{ employment.startDate | date }} -
                {{ employment.endDate | date }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col log-entry-organisation-name">
              <span>{{ employment.department.displayName }}</span>
              {{ organisation?.name }}
            </div>
          </div>
        </div>
        <div *ngIf="oldEmployments.length === 0">
          <div class="row">
            <div class="col log-large-text">
              {{ ("noPastEmployments" | i18n) || "Keine vergangenen Einsätze" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #loadingTemplate>
  <div class="d-flex align-items-center justify-content-center">
    <mat-spinner diameter="24"></mat-spinner>
  </div>
</ng-template>
